import { render } from "./Activities.vue?vue&type=template&id=cf2e4ee8&scoped=true"
import script from "./Activities.vue?vue&type=script&lang=js"
export * from "./Activities.vue?vue&type=script&lang=js"

import "./Activities.vue?vue&type=style&index=0&id=cf2e4ee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf2e4ee8"]])

export default __exports__